/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { debounce } from 'ecosystem-marketplace-core/utils/debounce';
import * as ActionTypes from '../actions/ActionTypes';
import { SEARCH_KEY, MINIMUM_SEARCH_LENGTH } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { getReviewFilters } from '../selectors/reviews';
import { getReviews } from '../actions/ReviewsActions';
const debouncedUpdate = debounce((dispatch, trackInteraction, ...args) => {
  dispatch(...args);

  if (trackInteraction) {
    trackInteraction();
  }
});
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);

  if (result.type === ActionTypes.REVIEW_FILTERS_UPDATED) {
    const {
      trackInteraction
    } = action.meta;
    const searchQuery = getReviewFilters(getState()).toSearchQuery();

    if (result.payload.hasOwnProperty(SEARCH_KEY.toLowerCase())) {
      const {
        search
      } = searchQuery;

      if (!search || search.length < MINIMUM_SEARCH_LENGTH) {
        searchQuery.search = undefined;
      }

      debouncedUpdate(dispatch, trackInteraction, getReviews(searchQuery));
    } else {
      dispatch(getReviews(searchQuery));
      trackInteraction();
    }
  }

  return result;
});